import { Injectable } from '@angular/core';
import { Firestore, collection, collectionData, query, where } from '@angular/fire/firestore';
import { Observable, map } from 'rxjs';
import { JobDto } from '../../models/job-dto';

@Injectable({
  providedIn: 'root'
})
export class JobService {

  constructor(private firestore: Firestore) { }

  // Get all jobs
  private getAllJobs(): Observable<JobDto[]> {
    const jobsRef = collection(this.firestore, 'jobs');
    return collectionData(jobsRef, { idField: 'id' }) as Observable<JobDto[]>;
  }

  // Get jobs by category
  getJobsByCategory(category: string): Observable<JobDto[]> {
    const jobsRef = collection(this.firestore, 'jobs');
    const q = query(jobsRef, where('category', '==', category));
    return collectionData(q, { idField: 'id' }) as Observable<JobDto[]>;
  }

  // Get unique categories
  getAllCategories(): Observable<string[]> {
    return this.getAllJobs().pipe(
      map(jobs => {
        const categoriesSet = new Set(jobs.map(job => job.category));
        return Array.from(categoriesSet);
      })
    );
  }

}
